module.exports = __webpack_public_path__ + "img/methodical-organiser.69bf65ea.svg";